import { postRequest } from '../clients/axios';
import { SavePlayerBioPayload } from '../models';

export const postSavePlayerBio = async (data: SavePlayerBioPayload) => {
  const url = 'player/saveplayerbio';
  const response = await postRequest<any>(url, data);
  return response;
};
